// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-contact-js": () => import("./../../../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-menu-js": () => import("./../../../src/pages/menu.js" /* webpackChunkName: "component---src-pages-menu-js" */),
  "component---src-pages-order-online-js": () => import("./../../../src/pages/order-online.js" /* webpackChunkName: "component---src-pages-order-online-js" */),
  "component---src-pages-pizzerias-js": () => import("./../../../src/pages/pizzerias.js" /* webpackChunkName: "component---src-pages-pizzerias-js" */)
}

